import { render, staticRenderFns } from "./ProjectWeeks.vue?vue&type=template&id=1baa0554"
import script from "./ProjectWeeks.vue?vue&type=script&lang=js"
export * from "./ProjectWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports